var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('excel-parse-window',{attrs:{"title":_vm.$t('PRODUCT.CATEGORIZATION.BULK_REGISTRATION_TITLE'),"notice-list":_vm.$t('PRODUCT.CATEGORIZATION.BULK_REGISTRATION_INFORMATION')
      .toString()
      .split('\n')}})}
var staticRenderFns = []

export { render, staticRenderFns }